import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Container, Image } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { Button, Card, CardContent, CardHeader, CardMedia, Divider, Grid } from '@mui/material';
import PlanConfirmDialog from './common/PlanConfirmDialog';
import parse, { domToReact } from 'html-react-parser'
import { LoginInfo } from '../App';
import UserMark from './UserMark';

const PlanMiniOfficial = (props) => {
	async function getTerms(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/messages/terms").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    // 翻訳
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // ナビゲート
    const navigate = useNavigate()
    const location = useLocation()
	const [terms,setTerms] = useState("")

	useEffect(() => {

	},[location.pathname])

    return(
    <Grid xs={12} sm={12} md={6} lg={4} xl={3} xxl={3} className='mb-3 d-none'>
        <Card sx={{ maxWidth: 300 }} style={{cursor:"pointer"}} onClick={() => {navigate("/legal")}}>
            <CardMedia component={"img"} image='/img/plan.webp' height={150} />
            <CardContent>
                プレミアムプラン <UserMark plan="plus" dialog={() => {}} />
            </CardContent>
        </Card>
    </Grid>
    )
}

export default PlanMiniOfficial;
